export const optimizeImage = (url) => {
  return `${url}/m/filters:quality(50)/`;
};
